import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios.ts';
import { type MutationConfig } from 'src/lib/react-query.ts';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex.ts';

import type { AdditionalServices } from 'src/features/parkingManagement/types/additionalServices.ts';

export type CreateAdditionalServicesFnType = typeof createAdditionalServices;

const RESOURCE = '/parkings/:parkingId/additional-service/';

export type CreateAdditionalServicesType = Omit<AdditionalServices, 'id' | 'tax_amount' | 'price'>;
export type DTO = {
    parkingId: string;
};

const createAdditionalServices = ({ parkingId, ...data }: DTO): Promise<CreateAdditionalServicesType> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

interface UseCreateAdditionalServicesOptions
    extends MutationConfig<CreateAdditionalServicesFnType, GeneralSmartParkError> {}

export const useCreateAdditionalServices = (options: UseCreateAdditionalServicesOptions) =>
    useMutation({
        mutationFn: createAdditionalServices,
        ...options,
    });
